"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withBasedRouter = _interopRequireDefault(require("@devsta/with-based-router"));

var _commonReact = require("@devsta/common-react");

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

var _ManagePosts = _interopRequireDefault(require("../components/ManagePosts"));

var _api = require("../../../common/api");

var _api2 = require("../api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ManagePostsContainer(_ref) {
  var history = _ref.history,
      location = _ref.location;
  return _react.default.createElement(_commonReact.AuthorisationConsumer, {
    requiresOrganisation: true
  }, function (_ref2) {
    var _ref2$selectedOrganis = _ref2.selectedOrganisation,
        organisationId = _ref2$selectedOrganis.organisationId,
        orgPermissions = _ref2$selectedOrganis.permissions;
    return _react.default.createElement(_commonReact.RequestProvider, {
      requests: {
        getInspirations: (0, _api.getInspirationsApi)({
          organisationId: organisationId
        }),
        updateInspirations: (0, _api2.updateInspirationsApi)(),
        deleteInspiration: (0, _api2.deleteInspirationApi)(),
        setInspirationFeatured: (0, _api2.setInspirationFeaturedApi)(),
        updateInspiration: (0, _api.updateInspirationApi)()
      }
    }, function (_ref3) {
      var getInspirations = _ref3.getInspirations,
          updateInspirations = _ref3.updateInspirations,
          deleteInspiration = _ref3.deleteInspiration,
          setInspirationFeatured = _ref3.setInspirationFeatured,
          updateInspiration = _ref3.updateInspiration;
      return _react.default.createElement(_commonReact.UploaderConsumer, null, function (_ref4) {
        var fetchAssets = _ref4.fetchAssets;
        return _react.default.createElement(_ManagePosts.default, {
          history: history,
          location: location,
          fetchAssets: fetchAssets,
          getInspirations: getInspirations,
          updateInspirations: updateInspirations,
          deleteInspiration: deleteInspiration,
          setInspirationFeatured: setInspirationFeatured,
          organisationId: organisationId,
          orgPermissions: orgPermissions,
          updateInspiration: updateInspiration
        });
      });
    });
  });
}

var _default = (0, _withBasedRouter.default)(_basePath.default, ManagePostsContainer);

exports.default = _default;